import { container, TYPES } from "../inversifyconfig/container.config"
import { IInternalAuth } from "../interfaces/inversifyDi"
import { ProcessHttp } from '../helpers/Auth'
import WorkspacesAction from '../redux/actions/workspaces/WorkspacesAction'
import ProfileAction from '../redux/actions/profile/ProfileAction'
import { IHttpRequest } from  "@/interfaces/IHttp"

export default class YourWorkspacesService  {

    router = store => dispatch => action => {

        switch (action.type) {
         
          case WorkspacesAction.REQUEST_WORKSPACES:
          case WorkspacesAction.REQUEST_ALLWORKSPACES:

            // If doest have token
            if (!ProcessHttp()){
              return dispatch(action)
            }

            // Get shortcode - should be global 
            let shortcode = window.location.host.split('.')[0];

            if (process.env.NODE_ENV === "development"){
              shortcode= "tab"
            }

            const top = action.type === WorkspacesAction.REQUEST_ALLWORKSPACES && store?.getState()?.workspaces?.totalWorkspaces || 5
               

            const includeUserAndGroupCounts = action.type === WorkspacesAction.REQUEST_WORKSPACES
            
            
            this.IInternalAuth().Check().then(() => {

                this.httpRequest().get(
                    `/apps?includeUserAndGroupCounts=${includeUserAndGroupCounts}&top=${top}&skip=0`
                ) 
                .then((x:any) => {
                    // Workspaces
                    if(action.type === WorkspacesAction.REQUEST_ALLWORKSPACES) {
                      store.dispatch(WorkspacesAction.receiveWorkspacesNoCounts(x.data.records))
                    }
                    else {
                      store.dispatch(WorkspacesAction.receiveWorkspaces(x.data.records)) 
                    }
                      
                    store.dispatch(WorkspacesAction.recieveTotalWorkspaces(x.data.remainingAppCount, x.data.total	))             
                })
                .catch((e) => {
                    console.error(e.message);          
                });
            }); 

            return dispatch(action)

          default:
            return dispatch(action)
        }
      }
      
      httpRequest() {

        let httpRequest = container.get<IHttpRequest>(TYPES.IHttpRequest);
    
        // No cache
        httpRequest.setHeaders({
          'Cache-control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0'           
        });
        
        return httpRequest;
      }
    
      IInternalAuth() {
        return container.get<IInternalAuth>(TYPES.IInternalAuth)
      }

}
